import React from 'react'
import { baseURL } from '../../../core'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../components/ui/tooltips'
import { Info } from 'lucide-react'
import { Button } from '../../../components/ui/button'

const UpdateFaceID: React.FC = () => {
  const handleUpdateFaceID = async () => {
    try {
      const url = `${baseURL}/face/register`
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const data = await response.json()

      if (data.statusCode === 200) {
        window.location.href = data.data['VerificationUrl']
      }
    } catch (error) {
      console.error('Error fetching verification URL:', error)
    }
  }

  return (
    <div className="flex items-center justify-between gap-2 border-t-1 py-4">
    <div className="flex flex-col gap-1">
      <h3 className="text-sm font-medium text-gray-900 flex items-center gap-2">
        Update Face ID 
        <TooltipProvider>
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <Info className="h-4 w-4 text-gray-500 cursor-help" />
            </TooltipTrigger>
            <TooltipContent side="top" className="ml-36 w-56 bg-[#F3F3F3]">
              <p className='text-xs font-extralight text-[#101B2C]'>
                Face ID update is not available at the moment. If you need assistance, please contact us
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </h3>
      <p className="text-sm text-gray-500">
        Need a new scan? Update your face ID so you can
        continue using AyeFace with ease
      </p>
      <p className="text-sm italic text-gray-500">
        Biometric last updated: July 13, 2024
      </p>
    </div>
    <Button
      type="button"
      className="min-w-24 disabled:bg-gray-700"
      onClick={handleUpdateFaceID}
      disabled
    >
      Update
    </Button>
  </div>
  )
}

export default UpdateFaceID